<template>
  <div>
    <Dialog
      :visible.sync="cityTownForm1"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="City Town Details"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="cityTownName">Name</label>
          <InputText
            id="cityTownName"
            v-model.trim="cityTown.cityTownName"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !cityTown.cityTownName }"
            :disabled="disabledArr.includes('cityTownName')"
          />
          <small class="p-invalid" v-if="submitted && !cityTown.cityTownName"
            >Name is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="active">Mark Active</label>
          <SelectButton
            v-model="cityTown.active"
            :options="options"
            optionLabel="name"
          />
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="postCodeArea">Postal Area</label>
          <InputText
            id="postCodeArea"
            v-model.trim="cityTown.postCodeArea"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !cityTown.postCodeArea }"
            :disabled="disabledArr.includes('postCodeArea')"
          />
          <small class="p-invalid" v-if="submitted && !cityTown.postCodeArea"
            >Postal Area is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="county">County</label>
          <InputText
            id="county"
            v-model.trim="cityTown.county"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !cityTown.county }"
            :disabled="disabledArr.includes('county')"
          />
          <small class="p-invalid" v-if="submitted && !cityTown.county"
            >County is required.</small
          >
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="country">Country</label>
          <InputText
            id="country"
            v-model.trim="cityTown.country"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !cityTown.country }"
            :disabled="disabledArr.includes('country')"
          />
          <small class="p-invalid" v-if="submitted && !cityTown.country"
            >Country is required.</small
          >
        </div>
        <div class="p-field p-col"></div>
      </div>

      <template #footer>
        <Button
          label="Reset"
          icon="pi pi-refresh"
          class="p-button-text"
          @click="reset"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-text"
          @click="save"
        />
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
          @click="cancel"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  props: [
    "citiesTownsToEdit",
    "citiesTownsForm",
    "sendingRequest",
    "disabledArr"
  ],
  data: () => ({
    cityTown: {},
    submitted: false,
    options: [
      { name: "Active", value: true },
      { name: "Inactive", value: false }
    ]
  }),
  created() {
    if (this.citiesTownsToEdit && this.citiesTownsToEdit.id) {
      this.cityTown = { ...this.citiesTownsToEdit };
      this.citiesTownsToEdit.active
        ? (this.cityTown.active = { name: "Active", value: true })
        : (this.cityTown.active = { name: "Inactive", value: false });
    }
  },
  computed: {
    cityTownForm1: {
      set(val) {
        if (!val) {
          this.cancel();
        }
      },
      get() {
        return this.citiesTownsForm ? true : false;
      }
    }
  },
  methods: {
    reset() {
      this.cityTown = {};
    },
    save() {
      this.submitted = true;

      let obj = { ...this.cityTown };

      if (obj.cityTownName && obj.postCodeArea && obj.country) {
        if (obj.active instanceof Object) {
          obj.active = obj.active.value;
        }

        this.$emit("save", obj);
      }
    },
    cancel() {
      this.$emit("close");
    }
  }
};
</script>

<style></style>
